<template>
  <div class="content">
	<app-header></app-header>
	<div class = "companyContent">
		<h2>{{theTitle}}</h2>	
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>单位名称：</i>
			<input v-model = "companyName" type="text" placeholder="请输入单位名称"/>
		</p>	 -->
		<p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>标题：</i>
			<!-- <input v-model = "jobReloName" type="text" placeholder="请输入职位名称"/> -->
			<el-input v-model="jobReloName" style="width:480px;" placeholder="请输入标题"></el-input>
		</p>
		<p class="basicMsg theAreas">
			<i class="editTitle"><span class="importants">&lowast;</span>所属区域：</i>
			<!-- <select name="city" v-model="companyCity" @change="changeJobCity" id="">
				<option value="">请选择工作地点</option>
				<option v-for ="(items) in cityList" :value="items.name" :key="items.id">{{items.name}}</option>			
			</select> -->
			<el-select style="width:480px;" v-model="companyCity" filterable placeholder="请选择所属区域，可搜索">
				<el-option
				v-for="item in cityList"
				:key="item.id"
				:label="item.name"
				:value="item.name">
				</el-option>
			</el-select>
			<!-- <select v-model = "areas" name="" id="">
				<option value="">请选择工作地点</option>
				<option v-for ="(items) in areasList" :value="items.name" :key="items.id">{{items.name}}</option>			
			</select>
			<input type="text" v-model="comAddress" style="width: 276px;"> -->
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>所属专业：</i>
			<!-- <select v-model = "major" name="" id="">
				<option value="">请选择所属专业</option>
				<option v-for = "items in majorList" :value="items.dictCode" :key="items.id">{{items.dictLabel}}</option>
			</select>  -->
			<el-select v-model="major" style="width:480px;" multiple placeholder="请选择所属专业，可多选">
				<el-option
				v-for="item in majorList"
				:key="item.id"
				:label="item.dictLabel"
				:value="item.dictValue">
				</el-option>
			</el-select>
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>所属分类：</i>
			<!-- <select v-model = "jobSort" @change="changeJobSort()" name="" id="">
				<option value="">请选择所属分类</option>
				<option v-for = "items in jobList" :value="items.dictCode" :key="items.id">{{items.dictLabel}}</option>
			</select>  -->
			  <el-cascader
			  	style="width:480px;"
				:options="options"
				:props="props"
				:show-all-levels="false"
				v-model = "jobSort"
				placeholder="请选择所属分类，可多选"
				clearable>
			</el-cascader>
		</p>
		<p class="basicMsg">
			<i class="editTitle">简历接收邮箱：</i>
			<!-- <input v-model = "jobReloName" type="text" placeholder="请输入职位名称"/> -->
			<el-input v-model="emails" style="width:480px;" placeholder="请输入邮箱"></el-input>
		</p>
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>行业：</i>
			<select v-model = "industry" name="" id="">
				<option value="">请选择所属行业</option>
				<option v-for = "items in industryList" :value="items.dictCode" :key="items.id">{{items.dictLabel}}</option>
			</select> 
		</p> -->
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>专业：</i>
			<select v-model = "major" name="" id="">
				<option value="">请选择所属专业</option>
				<option v-for = "items in majorList" :value="items.dictCode" :key="items.id">{{items.dictLabel}}</option>
			</select> 
		</p> -->
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>所属分类：</i>
			<select v-model = "jobName" name="" id="">
				<option value="">请选择所属分类</option>
				<option v-for = "items in jobListDetail" :value="items.code" :key="items.id">{{items.name}}</option>
			</select>
		</p> -->
		<!-- <p class="basicMsg theAreas">
			<i class="editTitle"><span class="importants">&lowast;</span>工作地点：</i>
			<select name="city" v-model="companyCity" @change="changeJobCity" id="">
				<option value="">请选择工作地点</option>
				<option v-for ="(items) in cityList" :value="items.name" :key="items.id">{{items.name}}</option>			
			</select>
			<select v-model = "areas" name="" id="">
				<option value="">请选择工作地点</option>
				<option v-for ="(items) in areasList" :value="items.name" :key="items.id">{{items.name}}</option>			
			</select>
			<input type="text" v-model="comAddress" style="width: 276px;">
		</p> -->
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>开始时间：</i>
			<date-picker v-model="jobBeginTime" lang="zh" format="YYYY-MM-DD" valueType="format"></date-picker>
		</p> -->
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>结束时间：</i>
			<date-picker v-model="jobEndTime" lang="zh" format="YYYY-MM-DD" valueType="format"></date-picker>
		</p> -->
		<!-- <p class="basicMsg count">
			<i class="editTitle"><span class="importants">&lowast;</span>招聘人数：</i>
			<span  class="icon iconfont selectCont"  @click="minus">&#xe66e;</span><input v-model = "headCount" type="text" /><span  class="icon iconfont selectCont" @click="add">&#xe66f;</span>
		</p> -->
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>报名方式：</i>
			<input v-model = "signUpMethod" type="text" placeholder="请输入报名方式"/>
		</p> -->

		<!-- <p class="basicMsg">
			<i style="vertical-align: top;" class="editTitle"><span class="importants">&lowast;</span>摘要：</i>
			<textarea v-model="abstracts" rows="10" cols="110">
			</textarea>		
		</p> -->
		<p class="basicMsg" style="vertical-align: top;">
			<i style="vertical-align: top;" class="editTitle">单位封面图：</i>
			<label class = "uploadImg">
				<img v-bind:src="comSrc" alt="科研人才网" />
				<input  type="file"  @change="cardNo()" id="saveCardNo" name="CardNo" />
			</label>
			<i style="vertical-align: top;color:red;">为了更好的显示，图片尺寸建议上传980*300</i>	
		</p>
		<p class="basicMsg" style="margin-top:30px;">
			<i style="vertical-align: top;" class="editTitle"><span class="importants">&lowast;</span>职位详情：</i><span>友情提示：您可以使用office Word办公软件，将招聘详情内容编辑排版，然后复制到该编辑框进一步完善。</span>
			<app-ckeditor  @func="getCkeditor" :ckeditorHeight="'700'" :editorText = "editorText"></app-ckeditor>
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importantsDiff"></span>备注：</i>
			<el-input v-model="remark" style="width:410px;" placeholder="请输入备注"></el-input>
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importantsDiff"></span>来源：</i>
			<el-input v-model="source" style="width:410px;" placeholder="请输入来源"></el-input>
		</p>
		<p class="submitAdd"><span @click = "saveWorkMsg">确认发布</span></p>
	</div>
	<div v-show = "pushSuccess" class="occlusion">
		<div class="occlusionCenter">
			<p class="pushSuccess">职位发布成功！</p>
			<p class="choseTODO"><span @click = 'goComCenter'>返回单位主页</span><span  @click = 'carryOn'>继续发布新职位</span></p>
		</div>
	</div>
	<app-footer></app-footer>
  </div>
</template>




<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
import AppCkeditor from '../../components/common/ckeditor.vue'
// import DatePicker from 'vue2-datepicker'
import {get, postWithJson, form} from '@/api/services'
export default {
  name: 'postJob',
  components: { AppFooter,AppHeader,AppCkeditor },
    data () {
    	return {
			id:"",//
			userName:'',//邮箱
    		theTitle:'发布招聘职位',
			morelinkFlag:false,
			emails:"",//邮箱
			// companyName:'',//公司名称
			jobReloName:'',//职位名称
			userId:'',//	  
			recruitId:'',//招聘主表id
			companyId:'',//
			// industryList:"",
			// industry:"",
			majorList:"",
			source:'',
			major:"",
			// jobListDetail:'',//所诉分类列表
			jobList:'',//所诉类别列表
			// comAddress:'',//公司地址
			cityList:{},
			// areasList:{},
			// jobBeginTime:'',//开始时间
			// jobEndTime:'',//结束时间
			jobSort:'',//行业分类
			// jobName:'',//职位名称	
			// headCount:1,//招聘人数
			companyCity:'',//城市
			// areas:"", //区域	
			editorText:'',//职位简介
			trade:'',//行业
			pushSuccess:false,//是否发布成功
			// abstracts:'',//摘要
			// signUpMethod:'',//报名方式
			remark:'',//备注
			recruitDetailId:'',//招聘详情id
			comSrc:require("../../assets/imgs/addEnvironment.png"),//机构图片
			props: { multiple: true },
			options: [{
					value: "gao_xiao",
					label: '高等院校',
					children: [{
							value: "pu_tong_ben_ke",
							label: '普通本科',
						}, {
							value: "gao_zhi_yuan_xiao",
							label: '高职院校',
						}, {
							value: "gao_deng_jiao_xue_ke_yan",
							label: '教学科研',
						}, {
							value: "jiao_fu_gang_wei",
							label: '教辅岗位',
						}]
				}, {
					value: "ke_yan_yuan_suo",
					label: '科研院所',
					children: [{
							value: "ke_yan_jiao_xue_ke_yan",
							label: '教学科研',
						}, {
							value: "xing_zheng_gang_wei",
							label: '行政岗位',
					}]
				}, {
					value: "yi_yao_wei_sheng",
					label: '医药卫生',
					children: [{
							value: "yi_yao_wei_sheng",
							label: '医药卫生',
					}]
				}, {
					value: "zhi_ming_qi_ye",
					label: '知名企业',
					children: [{
						value: "zhi_ming_qi_ye",
						label: '知名企业',
					}]
				}, {
					value: "shi_ye_dan_wei",
					label: '事业单位',
					children: [{
							value: "yin_cai_zhuan_xiang",
							label: '引才专项',
					},{
						value: "shi_ye_dan_wei_zhao_pin",
						label: '事业单位招聘',
					}]
				}, {
					value: "shuo_bo_re_zhao",
					label: '硕博热招',
					children: [{
							value: "shuo_shi_zhao_pin",
							label: '硕士招聘',
					},{
						value: "bo_shi_zhao_ping",
						label: '博士招聘',
					}]
				}, {
					value: "zhi_ye_qing_bao",
					label: '职业情报',
					children: [{
							value: "zhi_ye_qing_bao",
							label: '职业情报',
					}]
				}, {
					value: "bo_shi_hou",
					label: '博后进站',
					children: [{
							value: "gao_xiao_bo_hou",
							label: '高校博后',
					},{
						value: "ke_yan_yuan_suo_bo_hou",
						label: '科研院所博后',
					},{
						value: "qi_ye_bo_hou",
						label: '企业',
					},
					// {
					// 	value: "guo_wai_bo_hou",
					// 	label: '国外博后',
					// }
					]
				}, {
					value: "zhuan_jia_te_ping",
					label: '高端职位',
					children: [{
						value: "zhong_gao_ceng_guan_li",
						label: '中高层管理人才',
					},{
						value: "xue_shu_dai_tou_ren",
						label: '学术带头人',
					}]
				}, {
					value: "guo_wai_xiang_mu",
					label: '国外项目',
					children: [{
							value: "bo_shi_zhao_sheng",
							label: '博士招生',
					},{
						value: "bo_hou_huo_yan_jiu_yuan_zhao_ping",
						label: '博后/研究生招聘',
					},{
						value: "fang_wen_xue_zhe",
						label: '访问学者',
					}]
				}, {
					value: "hai_gui_yin_jin",
					label: '海归引进',
					children: [{
							value: "shuo_shi_yin_jin",
							label: '硕士引进',
					},{
						value: "bo_shi_yin_jin",
						label: '博士引进',
					}]
				}, {
					value: "ke_chuang_zhuan_qu",
					label: '科创专区',
					children: [{
							value: "ke_chuang_zhuan_qu",
							label: '科创专区',
					}]
				}, 
				// {
				// 	value: "she_hui_jian_zhi",
				// 	label: '社会兼职',
				// 	children: [{
				// 			value: "she_hui_jian_zhi",
				// 			label: '社会兼职',
				// 	}]
				// }
			],
			// lang: {
			// 	days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			// 	months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
			// 	pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
			// 	placeholder: {
			// 	date: 'Select Date',
			// 	dateRange: 'Select Date Range'
			// 	}
			// },
			// custom range shortcuts
			shortcuts: [
				{
					text: 'Today',
					onClick: () => {
						this.time3 = [ new Date(), new Date() ]
					}
				}
			],
			timePickerOptions:{
				start: '00:00',
				step: '00:30',
				end: '23:30'
			}
    	}
	},
	created:function () {
		this.ifUpdete();
	},
	beforeMount:function(){
		this.getCompanyInfo(); //获取企业id
		this.beforeInputMsg();  //先获取企业注册信息		薪水分布等	
	},
	mounted:function(){
		
	},
  	methods:{
  		getCompanyInfo:function(){
			let _self = this;
			let userCoookie = this.getCookie("session_token");
			if(userCoookie == null || userCoookie == ""){
				this.$router.push({ path:'/login',query:{loginFlag:false}});
				return false;
			}
			_self.userName = localStorage.getItem('_userName');
			let myreg = /^1\d{10}$/;
			if(myreg.test(_self.userName) || _self.userName == ""){
				// this.flags = false;
				localStorage.setItem('_userName',"");
				this.$router.push({path:"/login"})
				return false;
			}else{
				this.emails = _self.userName;
			}
			postWithJson('front/user/getCompanyInfo',{email:_self.userName}).then(
				function(response) {
					if(response.data.status){
						let resData = response.data.data;
						_self.companyId = resData.id;
						// _self.companyName = resData.name;
						localStorage.setItem('_userId', _self.companyId);
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					_self.$message({
                        message: "请重试",
                        type: 'error'
                    });           
				}
			)	
			if(_self.companyId != "" &&  _self.companyId != null){
				this.$router.push({ path:'/login'})
			}				
		},
		getCkeditor(data){
			this.editorText = data;
		},
		cardNo(){ //上传单位图片
			let _self = this;
			let x = document.getElementById('saveCardNo').files[0];
			let params = new FormData() ; //创建一个form对象
			params.append('file',x,x.name);  //append 向form表单添加数据
			let config = {
			headers:{'Content-Type':'multipart/form-data'}
			};
			postWithJson("front/common/upload",params,config)
			.then(function(response){
				if(response.data.code == 0){
					_self.comSrc = response.data.url;
				}else{
					_self.$message({
						message: response.data.msg,
						type: 'error'
					});
				}          
			},
			function(response) {
				_self.$message({
					message: response.data.msg,
					type: 'error'
				}); 	            
			})
		},
		ifUpdete:function(){//判断是填写简历还是修改
			let _self = this;
			var jobUpdateId = localStorage.getItem('_jobUpdateId');
			if(jobUpdateId != "" && jobUpdateId != null && jobUpdateId != undefined){
				_self.theTitle = "修改招聘职位";
				postWithJson("front/recruit/queryRecruit",{recruitId:jobUpdateId}).then(
					function(response) {
						if(response.data.status){
							let resData = response.data.data[0];
							_self.recruitId = resData.recruitId;
							_self.jobReloName = resData.title;
							// _self.jobSort = resData.categoryCode;
							_self.companyCity = resData.province;
							_self.major = resData.major.split(",");
							_self.comSrc = resData.headPhoto|| require("../../assets/imgs/addEnvironment.png");
							_self.editorText = resData.contentHead;
							_self.remark = resData.remark;
							_self.source = resData.source;
							_self.recruitDetailId = resData.recruitDetailId;
							_self.emails = resData.pushEmail||localStorage.getItem('_userName');
							let options = _self.options
							// options.map(function(val,index,arr){
							// 	val,map(function(val1,index1,arr1){
									
							// 	});
							// });
							let codeString = resData.categoryCode;
							var categoryCode = [];
							for(var k in options){
								for(var p in options[k]){
									if(typeof(options[k][p]) =="object"){
										for(var n in options[k][p]){
											var arr1 = [];
											if(codeString.indexOf(options[k][p][n].value) >= 0){
												
												arr1.push(options[k].value);
												arr1.push(options[k][p][n].value);
												categoryCode.push(arr1)
											}
										}
									}	
								}
								
							}
							_self.jobSort = categoryCode;
							console.log(categoryCode);
						}else{
							_self.$message({
								message: response.data.msg,
								type: 'error'
							}); 
						}
					},
					function(response) {
						_self.$message({
							message: "请重试",
							type: 'error'
						}); 	            
					}
				)
			}
		},
		
		
		beforeInputMsg:function(){
	  		let _self = this;
			// 所属类别    
			get('front/dict/getDict',{dictType:'one_category'}).then(
				function(response) {
					if(response.data.status){
						_self.jobList = response.data.data;
					}else{
						_self.$message({
							message: response.data.msg,
							type: 'error'
						});
					}
				},
				function(response) {
					_self.$message({
							message: response.data.msg,
							type: 'error'
						});           
				}
			)
			// get('dict/getDict',{dictType:'ke_yan_hang_ye_xin_xi'}).then(
			// 	function(response) {
			// 		if(response.data.status){
			// 			_self.industryList = response.data.data;
			// 		}else{
			// 			_self.$message.error(response.data.msg); 
			// 		}
			// 	},
			// 	function(response) {
			// 		_self.$message.error(response.msg);           
			// 	}
			// )
			get('front/dict/getDict',{dictType:'zhuan_ye'}).then(
				function(response) {
					if(response.data.status){
						_self.majorList = response.data.data;
					}else{
						_self.$message({
							message: response.data.msg,
							type: 'error'
						}); 
					}
				},
				function(response) {
					_self.$message({
							message: response.data.msg,
							type: 'error'
						});           
				}
			)
			//
			//     城市
			get('front/region/getRegion',{level:"1"}).then(
				function(response) {
					if(response.data.status){
						_self.cityList = response.data.data;
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
						// _self.$message.error(response.data.message); 
					}
				},
				function(response) {
					_self.$message({
							message: response.data.message,
							type: 'error'
						});          
				}
			)
	  	},
		saveWorkMsg:function(){
			let _self = this;
			if(_self.jobReloName == ""){
				_self.$message({
					message: "请输入职位名称",
					type: 'error'
				});
			}
			if(_self.major == ""){
				_self.$message({
					message: "请选择专业",
					type: 'error'
				});
	  			return false;
			}

			if(_self.companyCity == ""){
				  _self.$message({
					message: "请选择城市",
					type: 'error'
				});
	  			return false;
			}
	  		if(_self.editorText == ''){
				_self.$message({
					message: "请输入职位描述",
					type: 'error'
				});
	  			return false;
			}
			// let myreg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
	  		// if(_self.emails == "" || !myreg.test(_self.emails)){
	  		// 	this.$message({
            //         message: '请输入正确的邮箱地址！',
            //         type: 'warning'
            //     });
	  		// 	return false;
	  		// }
			let imgs = "";
	  		if(_self.comSrc != require("../../assets/imgs/addEnvironment.png")){
				 imgs = _self.comSrc;
			}
			console.log(_self.jobSort)
			let jobSort = _self.jobSort.toString().split(",");
			jobSort = Array.from(new Set(jobSort.flat(Infinity))).join(",");
			let reqData = {
				recruitId:_self.recruitId,
				companyName:_self.companyName,
				title:_self.jobReloName,
				categoryCode:jobSort,//所属类别
				// categoryName:_self.jobName,//所属分类
				industry:_self.industry,//行业
				major:_self.major.join(","),//专业
				province:_self.companyCity,//省
				// city:_self.areas,//所属城市
				// address:_self.comAddress,//详细地址
				// abstracts:_self.abstracts,//摘要
				// beginTime:_self.jobBeginTime,
				// endTime:_self.jobEndTime,
				// recruitNum:_self.headCount,//招聘人数
				// signUpMethod:_self.signUpMethod,//报名方式
				contentHead:_self.editorText,
				contentFoot:'',
				pushEmail:_self.emails,
				imgs:"",
				headPhoto:imgs,
				remark:_self.remark,//备注
				source:_self.source,//来源
				companyId:_self.companyId,
				recruitDetailId:_self.recruitDetailId,//招聘主表id

			}
			postWithJson('front/recruit/addOrUpdate',reqData).then(
				function(response) {
					console.log(response);
					if(response.data.status){
						// this.$message({
						// 	message: '发布成功！',
						// 	type: 'success'
						// });
						_self.pushSuccess = true;
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					_self.$message({
							message: response.data.message,
							type: 'error'
						});           
				}
			)
		},
		goComCenter:function(){
			this.$router.push({ path:'/companyCerter'})
		},
		carryOn:function(){
			localStorage.setItem('_jobUpdateId', "");
			this.$router.go(0);
		},
		// onContentChange (val) {
	    //   this.editorText = val
	    // },
			
  	},
    
	
}
</script>

<style  lang = "less"  scoped="scoped">
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
    border-radius: 3px;
    background-color: #c1c1c1;
}
.content{
	width: 100%;
	min-height: 890px;
	position: relative;
	background-color: #F4F4F4;
	.navs{
		background-color: white;
	}
	.kindeditor-component{
		display: inline-block;
	}
	.header-right{
		height: 62px;
		line-height: 62px;	
		.head{
			width: 44px;
			height: 44px;
			border-radius: 50%;
			margin-top: 11px;
		}
		.header-msg{
			height: 44px;
			line-height: 20px;
			font-size: 12px;
			margin: 11px 12px 0;
			span{
				display: inline-block;
				height: 20px;
				line-height: 20px;
				margin: 0;
				color: #1787FB;
				width: 26px;
			}
		}
	}
	.companyContent{
		width: 1000px;
		margin: 140px auto 80px;
		background-color: #fff;
		padding: 40px 60px;
		box-sizing: border-box;
		h2{
			font-size: 20px;
			color: #444;
		}
		p{
			vertical-align: top;
			margin: 10px 0;
			font-size: 12px;
			color: #878787;
		}
		.theAreas{
			select{
				width: 198px;
			}
		}
		.count{
			vertical-align: middle;
			input[type='text']{
				height: 36px;
				line-height: 36px;
				vertical-align: middle;
				width: 60px;
				text-indent:0;
				text-align: center;
				font-size: 16px;
			}
			.selectCont{
				font-size: 40px;
				vertical-align: middle;
				cursor: pointer;
			}
		}
		.certificate{
			label{
				display: inline-block;
				padding: 0 5px;
				height: 44px;
				line-height: 44px;
				position: relative;
				border: 1px solid #878787;
				font-size: 14px;
				cursor: pointer;
				text-align: center;
				margin-right: 5px;
				.iconfont{
					position: absolute;
					display: inline-block;
					width: 30px;
					height: 30px;
					color: #1787FB;
					font-size: 40px;
					bottom: 2px;
					right: 10px;
				}
				
			}
			.checked{
				border-color: #1787FB;
				color: #1787FB;
			}
			input[type = 'radio']{
				visibility: hidden;
				margin-left: -12px;
			}
		}
		.companyLogo{
			vertical-align: top;
			label{
				display: inline-block;
				width: 72px;
				height: 66px;
				cursor: pointer;
			}
			i{
				vertical-align: top;
			}
			.advice{
				vertical-align: top;
				margin-left: 6px;
			}
			img{
				vertical-align: top;
				width: 72px;
				height: 66px;
			}
			input{
				visibility: hidden;
				/*width: 72px;
				height: 66px;
				border: none;
				background: url(../../assets/images/LOGOThumbnail.png) no-repeat 0 0;*/
			}
		}
		input[type = 'text']{
			width: 400px;
			height: 44px;
			border: none;
			background-color: #f8f8f8;
			text-indent: 10px;
		}
		select{
			width: 400px;
			height: 44px;
			border: none;
			background-color: #f8f8f8;
		}
		.editTitle{
			font-style: normal;
			font-size: 14px;
			color: #444;
			display: inline-block;
			width: 130px;
			height: 40px;
		}
		.introduction{
			vertical-align: top;
		}
		textarea{
			resize:none
		}
		.importants{
			color: red;
			margin-right: 4px;
		}
		.importantsDiff{
			margin-right: 9px;
		}
		.companyName{
			font-size: 16px;
			color: #444;
		}		
		.submitAdd{
			text-align: center;
			margin-bottom: 60px;
			margin-top: 20px;
			span{
				display: inline-block;
				width: 282px;
				height: 52px;
				line-height: 52px;
				text-align: center;
				background-color: #1787FB;
				cursor: pointer;
				color: white;
				font-size: 20px;
			}
		}
	}
	.occlusion{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,0.3);
		z-index: 99999;
		.occlusionCenter{
			width: 400px;
			height: 200px;
			background-color: white;
			position: absolute;
			top: 50%;
			left: 50%;
			margin-top: -100px;
			margin-left: -200px;
			border-radius:6px;
			box-sizing: border-box;
			padding:40px 20px;
			text-align: center;
			.pushSuccess{
				height: 40px;
				line-height: 40px;
				
			}
			.choseTODO{
				padding-top: 20px;
				span{
					display: inline-block;
					padding: 8px 10px;
					border: 2px solid #1787FB;
					cursor: pointer;
					margin: 0 10px;
				}
				span:first-child{
					background-color: #1787FB;
					color: white;
				}
			}
		}
	}
	.uploadImg{
		label{
			display: inline-block;
			width: 154px;
			height: 220px;
			margin-right: 22px;
			margin-top: 6px;
			cursor: pointer;
		}
		img{
			width: 480px;
			height: 220px;
		}
		input{
			visibility: hidden;
			width: 0;
			height: 0;
		}
	}	
}

</style>



// WEBPACK FOOTER //
// src/views/companyRegister/postJob.vue